export const TodoSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.29 10L7.29 11L3.4 14.65L1 12.25L2 11.25L3.4 12.65L6.29 10ZM15 12V14H8V12H15ZM15 7V9H8V7H15ZM6.29 2L7.29 3L3.4 6.66L1 4.25L2 3.25L3.4 4.66L6.29 2ZM15 2V4H8V2H15Z"
      fill="#696969"
    />
  </svg>
);
